import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import useCoverForProductReturn from 'hooks/media/useCoverForProductReturn'
import { Text } from 'styles/components/typography'

import { SectionWrapperStyled } from './styles'

/**
 * DHowReturn
 *
 * @param {object} props - properties of component
 * @returns {node} DHowReturn
 */
const WHowReturn = props => {
  const { data, index, isSquareHidden } = props
  const {
    locale,
    paths: { cdn_global, cdn },
  } = useContext(LocalizationContext)
  const { colors } = React.useContext(ThemeContext)
  const isRu = locale === RU
  const coverUrl = useCoverForProductReturn({ locale, cdn, cdn_global })

  const classNameInner = isRu ? 'inner--ru' : 'pb-4'

  return (
    <SectionWrapperStyled
      withOverlay={!isRu}
      classNameInner={`inner ${classNameInner}`}
      isRussia={isRu}
      coverUrl={coverUrl}
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.white}
        lineColor="light"
        textColor="dark"
      >
        <div className="row">
          <div className="col-12 col-md-5 col-lg-5 offset-md-1">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

WHowReturn.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

WHowReturn.defaultProps = {
  isSquareHidden: false,
}

export default WHowReturn
